module.exports = __webpack_public_path__ + "assets/icons/i_download.svg";